export default __webpack_public_path__ + "static/media/hero-bg-p.f5c2c8f0.jpg";